export default "__VITE_ASSET__BnpJhoi0__"